import styled, { keyframes } from 'styled-components';

const girar = keyframes`
  to { transform: rotate(360deg); }
`;

const Circulo = styled.div`
  width: 34px;
  height: 34px;
  border: 3px solid ${({ theme }) => theme.colors.sandDark};
  border-top-color: ${({ theme }) => theme.colors.sage};
  border-radius: 50%;
  animation: ${girar} 800ms linear infinite;
  margin: ${({ theme }) => theme.space.xl} auto;
`;

function Spinner() {
  return <Circulo role="status" aria-label="Cargando" />;
}

export default Spinner;
